import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { CURRENT_ENVIROMENT, SERVICE_END_POINT } from 'src/app/shared/index';
import { ComponentTypes, Attributes, DisplayRuleToBeApplied, Source, RefList } from 'src/app/model/ui-rule-response-model';
import { AttributeIdAndStyle } from 'src/app/model/ui.attribute.style.model';
import { DropdownConfig, DropdownOptions } from '../../../model/dropdown.model';
import { RadioBtnConfig, RadioButtonOptions } from '../../../model/radio.button.model';
import { SliderUiRuleConfig, stepValues } from 'src/app/model/slider-ui-rule-model';
import { RangeValidationConfig } from 'src/app/model/rangeValidation.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})

export class UIRulesService {
  private endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];
  constructor(private http: HttpClient) { }


  /**
   * @author Udai
   * @description This function extracts the rules for particular component
   */
  getUIRulesForgivenAttribute(attributeToFetch: string, jsonForGivenComp: ComponentTypes): Attributes {
    let rulesForGivenAttribute: Attributes;
    if (jsonForGivenComp && jsonForGivenComp.attributes && Array.isArray(jsonForGivenComp.attributes)) {
      rulesForGivenAttribute = jsonForGivenComp.attributes.find(({ attributeId }) => attributeId === attributeToFetch);
    }
    return rulesForGivenAttribute;
  }

  getDisplayEligibilityFlag(value: [string], operator: string, valueToCompare: string) {

    let displayFlag: boolean;
    switch (operator) {

      case "in": {
        displayFlag = value.includes(valueToCompare);
        break;
      }

      case "equals": {
        displayFlag = value[0] ? (value[0] === valueToCompare) : false;
        break;
      }
      default: {

      }
    }
    return displayFlag;
  }

  getEligibleListToDisplay(sourceFromJson: Source[], rulesToBeApplied: DisplayRuleToBeApplied): Source[] {
    let result;
    let eligibleListToDisplay = [];
    if (rulesToBeApplied) {
      sourceFromJson.forEach(element => {
        let flagsReturnedList = [];
        if (element.displayRule && Array.isArray(element.displayRule) && element.displayRule.length > 0) {
          element.displayRule.forEach(rule => {
            if (rule.attributeName === rulesToBeApplied.attNameToCompare) {
              let eligibleFlag = this.getDisplayEligibilityFlag(rule.value, rule.operator, rulesToBeApplied.valueToCompare);
              flagsReturnedList.push(eligibleFlag);
            }
          });
          if (flagsReturnedList && flagsReturnedList.length > 0) {
            if (flagsReturnedList.every((flag) => flag === true)) {
              eligibleListToDisplay.push(element);
            }

          }
        }
      });
    }
    else {
      eligibleListToDisplay = sourceFromJson;
    }
    return eligibleListToDisplay;
  }

  getEligibleListToDisplayForRefData(sourceFromJson: RefList[], rulesToBeApplied: DisplayRuleToBeApplied): Source[] {
    let eligibleListToDisplay = [];
    sourceFromJson.forEach(element => {
      if (element.refAttributeCode && rulesToBeApplied) {
        if (element.refAttributeCode === rulesToBeApplied.valueToCompare) {
          eligibleListToDisplay = element.lookupvalues;
        }
      } else {
        eligibleListToDisplay = element.lookupvalues;
      }
    });
    return eligibleListToDisplay;
  }

  getEligibleRefList(sourceFromJson: RefList[], rulesToBeApplied: DisplayRuleToBeApplied): RefList {
    let eligibleRefList: RefList;
    sourceFromJson.forEach(refData => {
      if (refData.refAttributeCode && rulesToBeApplied) {
        if (refData.refAttributeCode === rulesToBeApplied.valueToCompare) {
          eligibleRefList = refData;
        }
      } else {
        eligibleRefList = refData;
      }
    });
    return eligibleRefList;
  }

  getDropdownOptions(eligibleListToDisplay: Source[], rulesToBeApplied: DisplayRuleToBeApplied): DropdownOptions[] {
    let result = eligibleListToDisplay.map(dropdownObj => ({
      code: dropdownObj.code, value: dropdownObj.value,
      defaultValue: (dropdownObj.defaultValue ? dropdownObj.defaultValue : false)
    }));
    return result;
  }

  getRadioButtonOptions(eligibleListToDisplay: Source[], rulesToBeApplied: DisplayRuleToBeApplied): RadioButtonOptions[] {
    let result = eligibleListToDisplay.map(radioBtnObj => ({
      code: radioBtnObj.code, label: radioBtnObj.value,
      defaultValue: (radioBtnObj.defaultValue ? radioBtnObj.defaultValue : false)
    }));
    return result;
  }

  updateDropDownOptions(eligibleListToDisplay: Source[], rulesToBeApplied: DisplayRuleToBeApplied, attributeName: string): DropdownOptions[] {
    let result;
    switch (attributeName) {
      case 'source': {
        let sourceList;
        sourceList = eligibleListToDisplay.map(dropdownObj => ({
          code: dropdownObj.code, value: dropdownObj.value,
          defaultValue: (dropdownObj.defaultValue ? dropdownObj.defaultValue : false)
        }));
        sourceList.forEach((temp, index) => {
          if (temp.code === 'F') {
            temp.value = 'Sun Life Financial of Canada';
          }          
          if (temp.code === 'O') {
            temp.value = 'Phoenix Life';
          }
          if (temp.code === 'B') {
            sourceList.splice(index, 1);
          }
          if (temp.code === 'I') {
            temp.value = "Legal & General"
          }
        });
        sourceList.push({ code: 'B', value: 'None of the above', defaultValue: false })
        sourceList.splice(-1, 0, { code: 'D', value: 'More than one of the above', defaultValue: false });
        result = sourceList.map(dropdownObj => ({
          code: dropdownObj.code, value: dropdownObj.value,
          defaultValue: (dropdownObj.defaultValue ? dropdownObj.defaultValue : false)
        }));
        return result;
      }
      default: {
        result = eligibleListToDisplay.map(dropdownObj => ({
          code: dropdownObj.code, value: dropdownObj.value,
          defaultValue: (dropdownObj.defaultValue ? dropdownObj.defaultValue : false)
        }));
        return result;
      }
    }
  }

  createMapperForDropdown(jsonForGivenComp: Attributes, rulesToBeApplied: DisplayRuleToBeApplied,
    attributeIdAndStyleObj: AttributeIdAndStyle, formVal: string): DropdownConfig {
    let eligibleListToDisplay = this.getEligibleListToDisplayForRefData(jsonForGivenComp.refList, rulesToBeApplied);
    let styleKeyObjToApply;
    let styleValueObjToApply;
    if (attributeIdAndStyleObj && attributeIdAndStyleObj.keyCol) {
      styleKeyObjToApply = attributeIdAndStyleObj.keyCol
    }
    else {
      styleKeyObjToApply = {
        md: 12,
        sm: 3,
        xs: 3
      };
    }
    if (attributeIdAndStyleObj && attributeIdAndStyleObj.valCol) {
      styleValueObjToApply = attributeIdAndStyleObj.valCol
    }
    else {
      styleValueObjToApply = {
        md: 10,
        sm: 3,
        xs: 3
      };
    }
    let ddOptions = this.isDDOptionsModify(jsonForGivenComp.attributeName) ? this.updateDropDownOptions(eligibleListToDisplay, rulesToBeApplied, jsonForGivenComp.attributeName)
      : this.getDropdownOptions(eligibleListToDisplay, rulesToBeApplied);
    let dropdownConfigObj = {
      type: 'dropdown',
      label: jsonForGivenComp.attributeLabel,
      value: formVal ? formVal : '',
      name: jsonForGivenComp.attributeName,
      controlName: jsonForGivenComp.attributeName,
      defaultValue: this.getDefaultValue(ddOptions),
      isActive: true,
      required: true, // need to get the data type confirmed
      readonly: false,
      options: ddOptions,
      keyCol: styleKeyObjToApply,
      valCol: styleValueObjToApply,
      errorMessage: null
    }

    return dropdownConfigObj;
  }

  getDefaultValue(ddOptions) {
    let data = ddOptions.find(option => option.defaultValue === true);
    return (data ? data.code : '');
  }

  createMapperForRadioButton(jsonForGivenComp: Attributes, rulesToBeApplied: DisplayRuleToBeApplied,
    attributeIdAndStyleObj: AttributeIdAndStyle, formVal: string): RadioBtnConfig {
    let eligibleListToDisplay = this.getEligibleListToDisplayForRefData(jsonForGivenComp.refList, rulesToBeApplied);
    let radioButtonConfigObj = {
      label: jsonForGivenComp.attributeLabel,
      value: formVal ? formVal : '',
      name: jsonForGivenComp.attributeName,
      controlName: jsonForGivenComp.attributeName,
      required: true, // need to get the data type confirmed
      questionOptions: this.getRadioButtonOptions(eligibleListToDisplay, rulesToBeApplied),
    }
    return radioButtonConfigObj;
  }

  createMapperForRangeValidation(jsonForGivenComp: Attributes, rulesToBeApplied: DisplayRuleToBeApplied,
    attributeIdAndStyleObj: AttributeIdAndStyle, formVal: string): RangeValidationConfig {
    let eligibleRefData = this.getEligibleRefList(jsonForGivenComp.refList, rulesToBeApplied);
    let rangeValidationConfigObj = {
      controlName: jsonForGivenComp.attributeName,
      minValue: eligibleRefData && eligibleRefData.minValue !== null ? eligibleRefData.minValue : null,
      maxValue: eligibleRefData && eligibleRefData.maxValue !== null ? eligibleRefData.maxValue : null,
    }
    return rangeValidationConfigObj;
  }

  createMapperForProductOptions(jsonForGivenComp: Attributes, rulesToBeApplied: DisplayRuleToBeApplied,
    attributeIdAndStyleObj: AttributeIdAndStyle, formVal: string) {
    let eligibleListToDisplay = this.getEligibleListToDisplayForRefData(jsonForGivenComp.refList, rulesToBeApplied);
    let validProductOptions = [];
    eligibleListToDisplay.forEach(product => {
      validProductOptions.push(product.code);
    });
    return validProductOptions;
  }

  createMapperForSlider(jsonForGivenComp: Attributes, rulesToBeApplied: DisplayRuleToBeApplied,
    attributeIdAndStyleObj: AttributeIdAndStyle, formVal: number): SliderUiRuleConfig {
    let eligibleListToDisplay = this.getEligibleListToDisplayForRefData(jsonForGivenComp.refList, rulesToBeApplied);
    let eligibleRefData = this.getEligibleRefList(jsonForGivenComp.refList, rulesToBeApplied);
    let sliderConfigObj = {
      label: jsonForGivenComp.attributeLabel,
      value: formVal ? formVal : null,
      name: jsonForGivenComp.attributeName,
      controlName: jsonForGivenComp.attributeName,
      minValue: eligibleRefData && eligibleRefData.minValue !== null ? eligibleRefData.minValue : null,
      maxValue: eligibleRefData && eligibleRefData.maxValue !== null ? eligibleRefData.maxValue : null,
      stepsArray: eligibleListToDisplay != null ? this.getStepValues(eligibleListToDisplay,rulesToBeApplied) : null
    }
    return sliderConfigObj;
  }

  getStepValues(eligibleListToDisplay: Source[], rulesToBeApplied: DisplayRuleToBeApplied): stepValues[] {
    let result = eligibleListToDisplay.map(stepVal => ({
      value: stepVal.value ? Number(stepVal.value) : null
    }));
    return result;
  }

  isDDOptionsModify(attributeName: string): boolean {
    let res = false;
    switch (attributeName) {
      case 'source': {
        res = true;
        break;
      }
      default: {
        res = false;
      }
    }
    return res;
  }
}
